'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof String.prototype.padEnd === 'function' ? String.prototype.padEnd : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/string.prototype.padend/polyfill.js
// module id = 430
// module chunks = 35783957827783 172322841747965